import React, { useState, useEffect } from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import apiClient from "../apiClient";
import { groupByParent } from '../utils/group-by-parent'; // Assuming you have this utility function

export interface TagComponentProps {
  tagName: string[];
  setTagName: React.Dispatch<React.SetStateAction<string[]>>;
  disabled?: boolean;
};

export default function TagComponent(props: TagComponentProps) {
  const {
    tagName,
    setTagName,
    disabled = false,
  } = props;

  // handle response
  const [tags, setTags] = useState<string[]>([]);

  // notification snackbar
  const { enqueueSnackbar } = useSnackbar();

  const grouped = groupByParent(tags);

  const handleChange = (value: string) => {
    setTagName(prev =>
      prev.includes(value)
        ? prev.filter(item => item !== value)
        : [...prev, value]
    );
  };

  // get tag list
  useEffect(() => {
    if (!disabled) {
      const fetchData = async () => {
        try {
          const response = await apiClient.get('/sigcap/api/tag-filter-list/');
          setTags(response.data.tag_list);
        } catch (err) {
          enqueueSnackbar('Failed to fetch tag list', {
            variant: 'error',
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'center'
            }
          });
        }
      };
      fetchData();
    };
  }, [disabled, enqueueSnackbar]);

  return (
    <Box>
      {Object.entries(grouped).map(([parent, children]) => (
        <Box key={parent} sx={{ mb: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold">{parent}</Typography>
          {children.map(childFull => (
            <FormControlLabel
              key={`${parent}:${childFull}`}
              control={
                <Checkbox
                  size="small"
                  checked={tagName.includes(childFull)}
                  onChange={() => handleChange(childFull)}
                />
              }
              label={childFull.split(':')[1]}
              sx={{
                display: 'flex',
                alignItems: 'center',
                // allows wrapping
                whiteSpace: 'normal',
                wordBreak: 'break-word',
              }}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
};
